import { render, staticRenderFns } from "./PinButton.vue?vue&type=template&id=13093f18&"
import script from "./PinButton.vue?vue&type=script&lang=js&"
export * from "./PinButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports